import React from 'react';
import './BlogLoading.css';

const BlogLoading = () => {
    return (
        <div className="flex items-center justify-center min-h-auto xl:h-[400px]">
            <div className="relative flex flex-col items-center">
                {/* Paper background */}
                <div className="w-full xl:w-[300px] h-auto xl:h-[200px] bg-white rounded-lg shadow-lg p-8">
                    {/* Animated lines */}
                    <div className="space-y-4">
                        <div className="h-2 bg-gray-200 rounded-full animate-pulse w-3/4" />
                        <div className="h-2 bg-gray-200 rounded-full animate-pulse w-full" />
                        <div className="h-2 bg-gray-200 rounded-full animate-pulse w-5/6" />
                        <div className="h-2 bg-gray-200 rounded-full animate-pulse w-4/6" />
                    </div>
                </div>

                {/* Animated pencil */}
                <div className="absolute -right-4 -top-4 animate-writing">
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17.85 5.15L18.85 4.15C19.23 3.77 19.23 3.15 18.85 2.77L17.23 1.15C16.85 0.77 16.23 0.77 15.85 1.15L14.85 2.15L17.85 5.15Z" fill="#FFA726"/>
                        <path d="M14.85 2.15L4.15 12.85C3.85 13.15 3.85 13.67 4.15 13.97L6.03 15.85C6.33 16.15 6.85 16.15 7.15 15.85L17.85 5.15L14.85 2.15Z" fill="#FFB74D"/>
                        <path d="M3 20H21V22H3V20Z" fill="#784719"/>
                    </svg>
                </div>
            </div>
        </div>
    );
};

export default BlogLoading;
